import { useState } from 'react';
import { Field } from 'formik';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons';

import { FieldError } from '../field-error/field-error';

import styles from '../sign-up-form.module.css';

export function FieldPassword({
	id,
	label,
	placeholder,
	hasError,
	eyeClassName,
	t,
}) {
	const [visible, setVisible] = useState(false);

	return (
		<div className={styles.inputGroup}>
			<label htmlFor={id} className={styles.label}>
				{label}
			</label>
			<div className={styles.passwordContainer}>
				<Field
					id={id}
					name={id}
					type={visible ? 'text' : 'password'}
					autoComplete='new-password'
					placeholder={placeholder}
					className={`${styles.passInput} ${hasError ? styles.inputError : ''}`}
				/>
				<span
					className={eyeClassName}
					onClick={() => setVisible(isVisible => !isVisible)}
				>
					<FontAwesomeIcon icon={visible ? faEye : faEyeSlash} />
				</span>
			</div>
			<FieldError name={id} t={t} />
		</div>
	);
}
